import React, {FC} from 'react'

const Account: FC = () => {
  return (
    <div>Account</div>
  )
}

export default Account
